import type { TourStep } from "./GuidedTour";

/**
 * Defines all steps for the application's guided tour
 */
export const documentViewerTourSteps: TourStep[] = [
    {
        target: "#data-sources",
        title: "Drop down list with the data sources",
        description:
            "Select the data source here, you will then see the documents in the table below",
        position: "bottom",
    },
    {
        target: "#documents-table",
        title: "Documents table",
        description: `
        This table contains documents from the data source you selected
        You can sort or filter documents based on different columns
        If you select "RDS Reports" or "Field Service Reports" you can then chat with the document
        `,
        position: "bottom",
    },
    {
        target: "#search-inside-docs",
        title: "Search inside selected documents",
        description: "When filtering documents, you can use this button to chat with the document",
        position: "bottom",
    },
];
